import { Constants } from './constants';

export function addColumnOnLevel(column, columns, level) {
  if (level === Constants.CampaignLevel || level === Constants.AccountLevel) {
    columns.push(column({
      name: 'AdGroupName',
      title: 'ColumnName_AdGroup',
      sortable: true,
      type: 'string',
      helpId: 'pop_BA_Dimensions_AdGroup',
    }));
    columns.push(column({
      name: 'AdGroupId',
      title: 'ColumnName_AdgroupID',
      filterable: false,
      sortable: true,
      type: 'string',
    }));
  }

  if (level === Constants.AccountLevel) {
    columns.push(column({
      name: 'CampaignName',
      title: 'ColumnName_Campaign',
      sortable: true,
      type: 'string',
      helpId: 'pop_BA_Dimensions_Campaign',
    }));
    columns.push(column({
      name: 'CampaignId',
      title: 'Dimension_ColumnName_CampaignId',
      filterable: false,
      sortable: true,
      type: 'string',
    }));
  }
}
